import React, { useEffect, useState } from 'react'
import {
  BorrowButton,
  HomeWrapper,
  LendButton,
  TotalValueLockedWrapper,
  TVLAction,
  WhatIs,
  WhatIsBody,
  CallActionButton,
  MarketsTitle
} from './Styles'
import { Particles } from '../../Components/Particles'
import { useTVL } from '../../TVL/useTVL'
import AnimatedNumber from 'animated-number-react'
import { MarketsOverview } from '../Markets/Components/MarketsOverview'

export const Home = () => {
  const [tvl, setTvl] = useState(0)
  const { getTVL } = useTVL()

  useEffect(() => {
    if (!tvl) {
      getTVL().then(setTvl)
    }
  }, [getTVL, tvl])

  return (
    <HomeWrapper>
      <Particles>
        <TotalValueLockedWrapper>
          <h1>
            ${' '}
            <AnimatedNumber
              duration={500}
              value={String(tvl)}
              formatValue={(v) => Number(v).toLocaleString()}
            />
          </h1>
          <div>Total Value Locked in the Protocol</div>
          <TVLAction>
            <LendButton>LEND</LendButton>
            <BorrowButton>BORROW</BorrowButton>
          </TVLAction>
        </TotalValueLockedWrapper>
      </Particles>
      <WhatIs>
        <h1>What is uLend?</h1>
        <WhatIsBody>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
          sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
          est laborum.
        </WhatIsBody>
        <div>
          <CallActionButton>Explore More</CallActionButton>
        </div>
      </WhatIs>
      <MarketsTitle>
        <h1>Markets</h1>
      </MarketsTitle>
      <MarketsOverview />
    </HomeWrapper>
  )
}
